import { render } from "./headersection.vue?vue&type=template&id=5d383374&scoped=true"
import script from "./headersection.vue?vue&type=script&lang=js"
export * from "./headersection.vue?vue&type=script&lang=js"

import "./headersection.vue?vue&type=style&index=0&id=5d383374&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d383374"]])

export default __exports__